import FieldRulesManager from '@/manager/3.6/FieldRulesManager';
import IComp from '@/models/Comp';
import ICompAddress from '@/models/CompAddress';
import IFormFieldRules from '@/models/form-field/IFormFieldRules';

export default {
    /**
     * Build an array of form field rules from the given comp's source data.
     * Ignores form filler values, comp photos and comp data w/o a field id.
     * Will use any existing original value in place of transfer value.
     * @param comp
     * @returns an array of form field rules
     */
    buildFromComp(comp: IComp, excludeNoValueAndNoSourceInitial?: boolean): IFormFieldRules {
        const fieldRules = FieldRulesManager.buildFromComp(comp, excludeNoValueAndNoSourceInitial);
        return fieldRules;
    },

    /**
     * Build a form field rules object from the given comp's source data for the given fieldId.
     * Ignores form filler values and comp photos.
     * Will use any existing original value in place of transfer value.
     * @param comp
     * @param fieldId
     * @returns an array of form field rules having one or zero items based on the comp and fieldId.
     */
    buildFromCompForField(comp: IComp, fieldId: number): IFormFieldRules {
        const fieldRules = FieldRulesManager.buildFromCompForField(comp, fieldId);
        return fieldRules;
    },

    /**
     * Runs field rules through the FieldRulesManager.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param fieldRules
     * @returns the resulting FormFieldRuless or null on failure
     */
    async runFieldRulesForComp(compAddress: ICompAddress, fieldRules: IFormFieldRules): Promise<IFormFieldRules | null> {
        const formFieldRules = await FieldRulesManager.runFieldRulesForComp(compAddress, fieldRules);
        return formFieldRules;
    },
};
